import React, { FunctionComponent } from 'react';
import FooterStyle                  from './Footer.style';

export const Footer: FunctionComponent = () => {

  const year = new Date().getFullYear();

  return (
    <FooterStyle>
      &copy; {year}, thuGO | v{process.env.REACT_APP_VERSION}
    </FooterStyle>
  );

};
